import getDestinationsByDate from "./getDestinationsByDate";

export default (destinations=[])=>{
    return getDestinationsByDate(destinations).find(d => (
        d.state !== "completed" && 
        d.status !== "completed" && 
        d.state !== "cancelled" &&
        d.status !== "cancelled" 
    ));
}